module.exports = __webpack_public_path__ + "static/media/texture.9d9cebb0.svg";